<script setup lang="ts">
import type { NavigationModel } from '@/types/navigationModel';

defineOptions({
  name: 'MopNavigationTree',
});

defineProps({
  navItem: {
    type: Object as PropType<NavigationModel>,
    required: true,
  },
  level: {
    type: Number,
    default: 1,
  },
});
</script>

<template>
  <nav :class="`navigation-tree navigation-tree--${level}`">
    <div v-for="item in navItem.getChildren()" :key="item.getUid()">
      <UiNuxtLink v-bind="item.getLink()" :class="['navigation-tree__item']">
        {{ item.getName() }}
      </UiNuxtLink>
      <MopNavigationTree v-if="item.hasChildren()" :nav-item="item" :level="level + 1" />
    </div>
  </nav>
</template>
